module.exports = __webpack_public_path__ + "static/media/external-icon.828b36d0.svg";